import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { useRef } from 'react';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { user, loading } = useAuth();
  const hasShownToast = useRef(false);

  if (loading) return <div>Loading...</div>;

  // If user is not authenticated
  if (!user) {
    if (!hasShownToast.current) {
      toast.warning('Please log in to access this page.');
      hasShownToast.current = true;
    }
    return <Navigate to="/login" replace />;
  }

  // If specific role is required and user doesn't have it
  if (requiredRole && user.role !== requiredRole) {
    if (!hasShownToast.current) {
      toast.error('You do not have permission to access this page.');
      hasShownToast.current = true;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
